// extracted by mini-css-extract-plugin
module.exports = {"pageSidebar":"PageSidebar_pageSidebar__2Ikzs"};